import "./ContactForm.css";

export default function ContactForm() {
  return (
    <section className="cf-section">

      <div className="cf-container">

        {/* LEFT SIDE */}
        <div className="cf-left">
          <div className="cf-image-box">
            <img 
              src="https://images.unsplash.com/photo-1504674900247-0877df9cc836" 
              alt="Restaurant" 
            />
          </div>

          <h4 className="cf-visit-title">✦ VISIT US ✦</h4>

          <p className="cf-address">
            100 Kings Road, Sydney, NS, B1S 1A1
          </p>

          <p className="cf-timing">
            <span>BREAK FAST</span> – 07.00 am – 11:00 am<br />
            <span>LUNCH AND DINNER</span> – 11.00 am – closing time
          </p>

          <p className="cf-contact-info">
            Call: +85-123-456789 &nbsp; | &nbsp;  
            Email: noshandnector@gmail.com
          </p>
        </div>

        {/* MIDDLE GOLD DIVIDER */}
        <div className="cf-divider">
          <span>✦</span>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="cf-right">
          <h5 className="cf-write-title">✦ WRITE TO US ✦</h5>
          <h2 className="cf-heading">Message Us</h2>

          <p className="cf-subtext">
            Contact us – we aim to reply within 24 hours and are happy to help!
          </p>

          <form className="cf-form">
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Email" />
            <input type="text" placeholder="Phone Number" />
            <input type="text" placeholder="Subject" />
            <textarea placeholder="Message"></textarea>

            <button type="submit">SEND MESSAGE</button>
          </form>
        </div>

      </div>

    </section>
  );
}
